import React, { useState } from 'react';
import './Panel.css';
import '../../pages/Search/Search.css';
import SearchBar from '../Search/SearchBar';
import SearchResultsList from '../Search/SearchResultsList';


const SearchPanel = ({ onClose }) => {

    const [results, setResults] = useState([]);
  
  return (
    <div className="modal-panel">
      <div className="panel-header">
        <h2>Search</h2>
        <button onClick={onClose}>✖</button>
      </div>
      <div className="panel-body">
           <SearchBar setResults={setResults} />
           <SearchResultsList results={results} />
      </div>
    </div>
  );
};

export default SearchPanel;
